export function getNumberParts(num = 100, parts = 10) {
  const arr = [];

  for (let i = parts; i <= num; i += parts) {
    arr.push(i);
  }

  return arr;
}

export function getDecimalNumberParts(num = 1, parts = 0.1) {
  return getNumberParts(num * 100000, parts * 100000).map(i => i / 100000);
}

export function shuffle(data) {
  var array = data;
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var x = array[i];
    array[i] = array[j];
    array[j] = x;
  }
  return array;
}
